import React from "react";
import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import "../../assets/admin/css/styles.css";
import "../../assets/admin/js/scripts.js";
import Dashboard from "../../components/admin/Dashboard.js";
import Profile from "../../components/admin/Profile.js";
import Category from "../../components/admin/Category.js";
import ViewCategory from "../../components/admin/category/ViewCategory.js";
import AddProduct from "../../components/admin/products/AddProduct.js";
import ViewProduct from "../../components/admin/products/ViewProduct.js";
import OrderStatus from "../../components/admin/orders/OrderStatus.js";
import OrderList from "../../components/admin/orders/OrderList.js";
import OrderTracking from "../../components/admin/orders/OrderTracking.js";
import ViewPromotionalImg from "../../components/admin/products/ViewPromotionalImg.js";
import CreatePromotionalOffers from "../../components/admin/products/CreatePromotionalOffers.js";
import AddSubCategory from "../../components/admin/category/AddSubCategory.js";
import ViewSubcategory from "../../components/admin/category/ViewSubcategory.js";
import AddNotification from "../../components/admin/pages/AddNotification.js";
import { Link, useNavigate } from "react-router-dom";
import EditCategory from "../../components/admin/category/EditCategory.js";
import AddPromotionalImg from "../../components/admin/products/AddPromotionalImg.js";
import UpdateVersion from "../../components/admin/pages/UpdateVersion.js";
import AddDeliveryCost from "../../components/admin/pages/AddDeliveryCost.js";
import Delivered from "../../components/admin/status/Delivered.js";
import Cancelled from "../../components/admin/status/Cancelled.js";
import Shipped from "../../components/admin/status/Shipped.js";
import Processing from "../../components/admin/status/Processing.js";
import Accepted from "../../components/admin/status/Accepted.js";
import NotAccepted from "../../components/admin/status/NotAccepted.js";
import DropdownOfStatus from "../../components/admin/status/DropdownOfStatus.js";
import AddBankDetails from "../../components/admin/pages/AddBankDetails.js";
import ViewTrendingProducts from "../../components/admin/products/ViewTrandingProduct.js";
import AddCoupon from "../../components/admin/pages/AddCoupon.js";
import GetCoupons from "../../components/admin/pages/GetCoupon.js";
import Reports from "../../components/admin/pages/reports.js";
import AddBrand from "../../components/admin/category/AddBrand.js";
import GetAllBrands from "../../components/admin/category/ViewBrand.js";
import AddSpecifications from "../../components/admin/category/AddSpecification.js";
import GetAllspecificationkeys from "../../components/admin/category/ViewSpecification.js";
import AddFlashSale from "../../components/admin/pages/AddFlashSale.js";
import GetFlashSale from "../../components/admin/pages/GetFlashSale.js";
import BulkProductUpload from "../../components/admin/products/BulkProductUpload.js";
import ReferralFeature from "../../components/admin/pages/ReferralFeature.js";
import GiftProductDetails from "../../components/admin/pages/ViewReferralFeature.js";
import ImageUploading from "../../components/admin/products/ImageUploading.js";
import ViewImages from "../../components/admin/products/ViewImage.js";
import Analytics from "../../components/admin/pages/AppAnalytics.js";
import ProcessingData from "../../components/admin/orders/ProcessingData.jsx";
import CodOrders from "../../components/admin/orders/CODOrders.jsx";
import CodSales from "../../components/admin/orders/CodSales.jsx";
import SalesReport from "../../components/admin/orders/SalesReport.jsx";
import GetAllSeller from "../../components/admin/pages/GetAllSeller.jsx";
import SellerCommission from "../../components/admin/pages/Seller/SellerCommission.jsx";
import SellerProducts from "../../components/admin/pages/Seller/SellerProduct.jsx";
import AdminWithdrawRequests from "../../components/admin/pages/Seller/AdminWithdrawRequests.jsx";
import AdminWallet from "../../components/admin/pages/AdminWallet.jsx";
import ReleaseHoldAmount from "../../components/admin/pages/Seller/ReleaseHoldAmount.jsx";
import GetAllReseller from "../../components/admin/pages/GetAllReSeller.jsx";
import ResellerProductDetails from "../../websitecomponents/pages/ResellerProductDetails.jsx";
import ResellerWithdrawRequests from "../../components/admin/pages/Reseller/ResellerWithdrawRequests.jsx";
import ReleaseHoldAmountRe from "../../components/admin/pages/Reseller/ReleaseHoldAmountRe.jsx";
import ResellerProducts from "../../components/admin/pages/Reseller/ResellerProduct.jsx";
import GetAllResellerOrder from "../../components/admin/pages/Reseller/GetAllResellerOrder.jsx";
import GetAllSellerOrder from "../../components/admin/pages/Seller/GetAllSellerOrder.jsx";

const MasterLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      navigate("/");
    }
  }, []);

  return (
    <div className="sb-nav-fixed">
      <Navbar />
      <div id="layoutSidenav">
        <Sidebar />
        <div id="layoutSidenav_content">
          <main>
            <Routes>
              <Route path="admin" element={<Navigate to="/admin" />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="profile" element={<Profile />} />
              <Route path="add-Category" element={<Category />} />
              <Route path="ViewCategory" element={<ViewCategory />} />
              <Route path="AddProduct" element={<AddProduct />} />
              <Route path="ViewProduct" element={<ViewProduct />} />
              <Route path="OrderList" element={<OrderList />} />
              <Route path="OrderTracking" element={<OrderTracking />} />
              <Route path="OrderStatus" element={<OrderStatus />} />
              <Route
                path="CreatePromotionalOffers"
                element={<CreatePromotionalOffers />}
              />
              <Route path="ViewPromotional" element={<ViewPromotionalImg />} />
              <Route path="AddSubCategory" element={<AddSubCategory />} />
              <Route path="ViewSubcategory" element={<ViewSubcategory />} />
              <Route path="AddNotification" element={<AddNotification />} />
              <Route path="AddPromotionalImg" element={<AddPromotionalImg />} />
              <Route path="UpdateVersion" element={<UpdateVersion />} />
              <Route path="/AddDeliveryCost" element={<AddDeliveryCost />} />
              <Route path="/Delivered" element={<Delivered />} />
              <Route path="/Cancelled" element={<Cancelled />} />
              <Route path="/Shipped" element={<Shipped />} />
              <Route path="/Processing" element={<Processing />} />
              <Route path="/Accepted" element={<Accepted />} />
              <Route path="/NotAccepted" element={<NotAccepted />} />
              <Route path="/DropdownOfStatus" element={<DropdownOfStatus />} />
              <Route path="/AddBankDetails" element={<AddBankDetails />} />
              <Route
                path="/ViewTrandingProduct"
                element={<ViewTrendingProducts />}
              />
              <Route path="/AddCoupon" element={<AddCoupon />} />
              <Route path="/GetCoupon" element={<GetCoupons />} />
              <Route path="/Reports" element={<Reports />} />
              {/* <Route path="/ShippingLabel" element={<ShippingLabel />} /> */}
              <Route path="/AddBrand" element={<AddBrand />} />
              <Route path="GetAllBrands" element={<GetAllBrands />} />
              <Route
                path="/AddSpecifications"
                element={<AddSpecifications />}
              />
              <Route
                path="/GetAllSpecificationkeys"
                element={<GetAllspecificationkeys />}
              />
              <Route path="/AddFlashSale" element={<AddFlashSale />} />
              <Route path="/GetFlashSale" element={<GetFlashSale />} />
              <Route
                path="/BulkProductUpload"
                element={<BulkProductUpload />}
              />
              <Route path="/ReferralFeature" element={<ReferralFeature />} />
              <Route
                path="/GiftProductDetails"
                element={<GiftProductDetails />}
              />
              <Route path="/ImageUploading" element={<ImageUploading />} />
              <Route path="/ViewImages" element={<ViewImages />} />
              <Route path="/Analytics" element={<Analytics />} />
              <Route path="/ProcessingData" element={<ProcessingData />} />
              <Route path="/CodOrders" element={<CodOrders />} />
              <Route path="/CodSales" element={<CodSales />} />
              <Route path="/SalesReport" element={<SalesReport />} />
              <Route path="/GetAllSeller" element={<GetAllSeller />} />
              <Route path="/SellerCommission" element={<SellerCommission />} />
              <Route path="/SellerProducts" element={<SellerProducts />} />
              <Route path="/GetAllReseller" element={<GetAllReseller />} />

              <Route
                path="/GetAllSellerOrder"
                element={<GetAllSellerOrder />}
              />
              <Route
                path="adminWithdrawRequests"
                element={<AdminWithdrawRequests />}
              />
              {/* ReleaseHoldAmount */}
              <Route path="/AdminWallet" element={<AdminWallet />} />
              <Route
                path="/ReleaseHoldAmount"
                element={<ReleaseHoldAmount />}
              />
              <Route
                path="/reseller-product/:id"
                element={<ResellerProductDetails />}
              />
              <Route
                path="ResellerWithdrawRequests"
                element={<ResellerWithdrawRequests />}
              />
              <Route
                path="ReleaseHoldAmountRe"
                element={<ReleaseHoldAmountRe />}
              />
              <Route path="ResellerProducts" element={<ResellerProducts />} />
              <Route
                path="GetAllResellerOrder"
                element={<GetAllResellerOrder />}
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MasterLayout;
